<template>
  <span>
    <div @click="data.visible = !data.visible">
      <v-row>
        <v-col>
          <p class="title">
            {{ data.title }}
          </p>
        </v-col>

        <img
          v-if="data.visible"
          src="../../assets/pinjaman/minus-circle.png"
          srcset="
            ../../assets/pinjaman/minus-circle@2x.png 2x,
            ../../assets/pinjaman/minus-circle@3x.png 3x
          "
          class="minus-circle"
        />
        <img
          v-else
          src="../../assets/pinjaman/plus-circle.png"
          srcset="
            ../../assets/pinjaman/plus-circle@2x.png 2x,
            ../../assets/pinjaman/plus-circle@3x.png 3x
          "
          class="plus-circle"
        />
      </v-row>

      <div class="Desc pt-4" v-if="data.visible">
        <div class="pb-2 font-weight-bold">Responsibilities :</div>
        <div v-for="(resp, i) in data.responsibilities" :key="i" class="pb-1">
          {{ resp.id }}. {{ resp.content }}
        </div>

        <div class="pt-4 pb-2 font-weight-bold">Requirements :</div>
        <div v-for="(req, i) in data.requirements" :key="i" class="pb-1">
          {{ req.id }}. {{ req.content }}
        </div>

        <div class="pt-4">
          Join us to create greater impact and build something meaningful to
          others!
        </div>
        <div class="pt-2">
          Send ur latest <strong>CV and Portfolio</strong> to
          <strong class="red--text">join@dompetkilat.co.id</strong>
        </div>

        <v-row class="pt-8 pb-4 pl-2">
          <!-- <v-btn class="white--text text-none px-8" color="#252525" rounded
            >Daftar Sekarang</v-btn
          > -->
          <v-btn
            class="white--text text-none px-8"
            color="black"
            rounded
            @click="toEmail"
            >Daftar Sekarang</v-btn
          >
          <span class="px-1" />
          <a :href="data.glints" target="_blank">
            <img
              class="socialIcon"
              :src="require('../../assets/career/Glints.png')"
              alt
            />
          </a>
          <span class="px-1" />
          <a :href="data.linkedin" target="_blank">
            <img
              class="socialIcon"
              :src="require('../../assets/career/Linkedin.png')"
              alt
            />
          </a>
        </v-row>
      </div>
      <p class="Fade-Out" v-if="!data.visible" />
    </div>

    <v-divider />
  </span>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {};
  },
  methods: {
    toEmail() {
      window.location.href = "mailto:join@dompetkilat.co.id";
    },
  },
};
</script>

<style scoped>
.title {
  /* width: 533px; */
  height: 22px;
  flex-grow: 0;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Desc {
  /* width: 972px; */
  flex-grow: 0;
  margin-left: 10px;
  /* margin: 12px 56px 20px 0; */
  font-family: "Inter";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
  animation: fadein 1s;
}
.minus-circle {
  width: 20px;
  height: 20px;
  margin: 21px 30px 13px 56px;
  object-fit: contain;
}
.plus-circle {
  width: 20px;
  height: 20px;
  margin: 21px 30px 20px 56px;
  object-fit: contain;
  display: inline;
}
.truncated {
  max-width: 1000px;
}
.socialIcon {
  max-width: 42px;
  max-height: 42px;
  flex-grow: 0;
  object-fit: contain;
}
.Fade-Out {
  animation: fadeout 1s;
}

@keyframes fadein {
  0% {
    opacity: 0;
    height: 0px;
  }
  100% {
    opacity: 1;
    height: 380px;
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
    height: 380px;
  }
  100% {
    opacity: 0;
    height: 0px;
  }
}
</style>
